import { useEffect, useState } from "react";
import Button from "@/components/Button";
import Loading from "@/components/Loading";
import { useUserApi } from "@/hooks/useApi";

interface Props {
  isLoading: boolean;
  onAgree: () => void;
}

export default function TermsAndConditions({ isLoading, onAgree }: Props) {
  const [terms, setTerms] = useState<string>();
  const userApi = useUserApi();

  useEffect(() => {
    async function getTerms() {
      const tmpTerms = await userApi.userGetTermsAndConditions();
      setTerms(tmpTerms);
    }
    getTerms();
  }, [userApi]);

  return (
    <div className="d-flex justify-content-center h-100 flex-column align-items-center">
      <Loading isLoading={!terms}>
        <h1>Terms and conditions</h1>
        <div
          className="overflow-auto border p-3"
          style={{ height: "70vh", maxWidth: 700 }}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: safe html from our server
          dangerouslySetInnerHTML={{ __html: terms ?? "" }}
        />
        <Loading className="mt-3" isLoading={isLoading}>
          <Button className="mt-3" onClick={onAgree}>
            Agree and Continue
          </Button>
        </Loading>
      </Loading>
    </div>
  );
}
